export const dataHooks = {
  trendIndicatorValue: 'trendIndicator-value',
  trendIndicatorIcon: 'trendIndicator-icon',
  trendIndicatorUp: 'trendIndicator-sort-up-icon',
  trendIndicatorDown: 'trendIndicator-sort-down-icon',
};
